import React, { Component } from "react"
import { OverlayTrigger, Spinner, Tooltip } from "react-bootstrap"
import { shouldAllowAccess } from "src/utilities/helper"
import ReviewTypes from "../../ReviewTypes/EditReviewTypes"
import ReviewApprovalTypes from "../../ReviewTypes/ReviewApprovalTypes"
import "./ReviewApproval.css"

interface Props {
    approvals: Array<ReviewApprovalTypes>
    review: ReviewTypes
    approveReview: Function
    contextUserId: number | string
    loading: boolean
    readOnly: boolean
    isDelegation: boolean
    delegatorEmployeeId: number
}

interface State {
    input: string
}

class ReviewApproval extends Component<Props, State> {

    state = {
        input: ""
    }

    handleChange = (event: { target: { value: string } }) => {
        let input = event.target.value
        this.setState({ input: input })
    }

    manageState = (keys: Array<{ key: string, value?: any }>) => {
        let state: any = this.state
        for (let i = 0; i < keys.length; i++) {
            if (Object.entries(keys[i]).length > 1) {
                state[keys[i].key] = keys[i].value
            } else {
                state[keys[i].key] = !state[keys[i].key]
            }
        }
        this.setState(state)
    }

    getFirstNull = () => {
        for (let i = 0; i < this.props.approvals.length; i++) {
            if (!this.props.approvals[i].ApprovalDateUTC) {
                return i
            }
        }
        return 0
    }

    render() {

        const props = this.props
        const firstNull = this.getFirstNull()
        const hrApproval = (firstNull === this.props.approvals.length - 1) && shouldAllowAccess("HR:ADMIN")
        const approvals = this.props.approvals
        const isSubmitted = typeof (props.review.SubmittedDateUtc) === "string"
        let canApprove = false
        if (approvals[firstNull]) {
            canApprove = (approvals[firstNull].ApproverEmployeeId === parseInt(props.contextUserId + ""))
                || hrApproval
                || (props.isDelegation && approvals[firstNull].ApproverEmployeeId === parseInt(props.delegatorEmployeeId + ""))
        }

        let pillType = "Raised"

        // const ReviewApprovalToolTip = (text: string) => (
        //     <Tooltip id="employee-review-approval-tool-tip">
        //         {text}
        //     </Tooltip>
        // )

        // //console.log("??? approvals:", approvals)
        // //console.log("??? canApprove: ", canApprove)
        // //console.log("??? hrApproval: ", hrApproval)
        // //console.log("??? firstNull", firstNull)
        // console.log("??? props", props)
        // //console.log("??? state", state)


        const tt = (text: string) => (
            <Tooltip id="f6e5c9d24189bc992c87cdef57d8">
                {text}
            </Tooltip>
        )

        return (
            <div className="ReviewApproval">
                <div className={`ReviewApprovalHeader${pillType}`}>
                    <span className="material-icons">done_all</span>
                    <p>Approvals</p>
                    {props.loading && <Spinner id="review-manger-approval-spinner" animation="border" />}
                </div>
                {approvals.length > 0 && isSubmitted && approvals.map((item: ReviewApprovalTypes, index: number) =>
                    <div className="ReviewApprovalItem" key={item.EmployeeReviewApprovalId}>
                        <div className="ReviewApprovalItemLeft">
                            {item.ApprovalDateUTC && <span className="material-icons ReviewApprovalItemLeftApproved" >done</span>}
                            {!item.ApprovalDateUTC && <span className="material-icons ReviewApprovalItemLeftPending">hourglass_empty</span>}
                            <p>{item.DisplayName !== "HR User" ? item.DisplayName : "HR Approval"}</p>
                        </div>
                        {index === firstNull && !props.loading && <div className="ReviewApprovalItemRight">
                            {!approvals[index].ApprovalDateUTC && canApprove && <div className="ReviewApprovalItemRightApprove" onClick={() => this.props.approveReview(props.review.EmployeeReviewId, hrApproval)}>
                                <p>Approve</p>
                            </div>}

                            {!approvals[index].ApprovalDateUTC && canApprove && props.isDelegation && <div className="e984fd3a12334d20ac99cf9ba68ea606" onClick={() => this.props.approveReview(props.review.EmployeeReviewId, hrApproval)}>
                                {props.isDelegation &&
                                    <OverlayTrigger placement="right" overlay={tt(`Approve as a delegate for ${approvals[index].DisplayName}`)}>
                                            <span className="material-icons">info</span>
                                    </OverlayTrigger>
                                }
                            </div>}

                        </div>}
                    </div>
                )}
                {!isSubmitted && <div className="ReviewApprovalWaitingOnSubmit">
                    <p>Review not submitted</p>
                </div>}
            </div>
        )
    }
}

export default ReviewApproval